import _ from 'lodash';

export const storeClickData = (
  url, 
  token, 
  adElementId, 
  adPlaceId, 
  type,
  
  // for ad video videoWithAd
  dispId,
  displayType,
  vIndex,
  bClickTime,
  bIndex,
) => {
  return new Promise((resolve, reject) => {

    // const lsUserLocation = localStorage.getItem('userLocation') ? localStorage.getItem('userLocation') : '';
    // const lsUserSelectLng = localStorage.getItem('userSelectLng') 
    //   ? localStorage.getItem('userSelectLng') 
    //   : navigator.language;

    // fetch(url + `/ad-visit/store-click-visit?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}`, {
    // fetch(url + `/ad/ad-visit?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}`, {
      fetch(url + `/ad/ad-visit?userLocation=&selectLanguage=`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        adElementId: adElementId,
        adPlaceId: adPlaceId,
        type: type,
        dispId: dispId,
        displayType: displayType,
        vIndex: vIndex,
        bClickTime: bClickTime,
        bIndex: bIndex,
        // linkUrl: linkUrl,
        // geolocation: userLocation,
      })
    })
      .then(res => {
        if (res.status === 499) {
          throw new Error('budget-error');
        }
        
        if (res.status !== 200 && res.status !== 201) {
          throw new Error("Can't store click data");
        }
        return res.json();
      })
      .then(resData => {
        console.log(resData);
  
        resolve({ message: 'store click data success', data: resData });
      })
      .catch(err => {
        console.log(err);
        // resolve({ message: 'emailVerified fbUserId update failed', error: err });
        reject({ message: 'store click data failed', error: err });
      });
  });
};

export const storeAdVideoViewVisit = (
  url, 
  token, 
  adElementId, 
  adPlaceId, 
  type,
  dispId,
  displayType,
  videoTime,
  isClick,
  vIndex,
) => {
  return new Promise((resolve, reject) => {
    console.log('storeAdVideoViewVisit');
    
    const lsUserLocation = localStorage.getItem('userLocation') ? localStorage.getItem('userLocation') : '';
    const lsUserSelectLng = localStorage.getItem('userSelectLng') 
      ? localStorage.getItem('userSelectLng') 
      : navigator.language;

    // fetch(url + `/ad-visit/store-click-visit?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}`, {
    fetch(url + `/ad/ad-video-view-visit?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        adElementId: adElementId,
        adPlaceId: adPlaceId,
        type: type,
        dispId: dispId,
        displayType: displayType,
        videoTime: videoTime,
        isClick: isClick,
        vIndex: vIndex,
        // linkUrl: linkUrl,
        // geolocation: userLocation,
      })
    })
      .then(res => {
        if (res.status === 499) {
          throw new Error('budget-error');
        }

        if (res.status !== 200 && res.status !== 201) {
          throw new Error("Can't store click data");
        }
        return res.json();
      })
      .then(resData => {
        console.log(resData);
  
        resolve({ message: 'store click data success', data: resData });
      })
      .catch(err => {
        console.log(err);
        // resolve({ message: 'emailVerified fbUserId update failed', error: err });
        reject({ message: 'store click data failed', error: err });
      });
  });
};

export const getNearAdElements = (url, token, adType) => {
  return new Promise(async (resolve, reject) => {
    try {
      const lsUserLocation = localStorage.getItem('userLocation') ? localStorage.getItem('userLocation') : '';
      const lsUserSelectLng = localStorage.getItem('userSelectLng') 
        ? localStorage.getItem('userSelectLng') 
        : navigator.language;
      const qAdType = adType || '';

      // const response = await fetch(url + `/ad-filter-element/near-ad-elements?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}`, {
      const response = await fetch(url + `/ad/near-adelements?userLocation=${lsUserLocation}&selectLanguage=${lsUserSelectLng}&adType=${qAdType}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
      });

      if (response.ok) {
        const resData = await response.json();
        resolve(resData);
      } else {
        reject({ message: 'get ads failed' });
      }
    } 
    catch (err) {
      console.log(err);
      reject(err);
    }

  });
};

export const createDisplayAd = (list) => {

  //// weight, other factors filter...
  const randomIndex = Math.floor(Math.random() * list.length);
  const randomValue = list[randomIndex];

  return randomValue;
};

export const createWithAdIndexList = () => {
  const twoToFour = [];
  const fiveToNine = [];
  const tenToFourteen = [];
  const fifteenToNineteen = [];
  for (let i=0; i<20; i++) {
    // numArray.push(i);
    if (i>=2 && i < 5 ) {
      twoToFour.push(i);
    }
    if (i >= 5 && i < 10) {
      fiveToNine.push(i);
    }
    if (i >= 10 && i < 15) {
      tenToFourteen.push(i);
    }
    if (i >= 15) {
      fifteenToNineteen.push(i);
    }
  }
  // console.log(numArray);

  // console.log('zeroToFour', zeroToFour, fiveToNine, tenToFourteen, fifteenToNineteen);
  const sample1 = _.sample(twoToFour);
  const sample2 = _.sample(fiveToNine);
  const sample3 = _.sample(tenToFourteen);
  const sample4 = _.sample(fifteenToNineteen);

  const numArray = [sample1, sample2, sample3, sample4];
  // console.log('numArray', numArray);

  return numArray;
}

const testFunction = () => {
  console.log('test function called!!')
}
